// Detailed solution domain content adapted from Silent Sentry's Technology Solution Map (mocked frontend data)
export const solutionDetails = {
  "cybersecurity-risk-management": {
    title: "Cybersecurity & Risk Management",
    overline: "Defense-First Security",
    intro:
      "A full-lifecycle security practice built on the NIST framework — identify, protect, detect, and respond. We architect layered defenses that satisfy the strictest compliance mandates, from CMMC to HIPAA.",
    groups: [
      { name: "Identify", items: ["Virtual CISO", "Vulnerability Assessments", "Penetration Testing", "Governance, Risk & Compliance", "Security Awareness Training"] },
      { name: "Protect", items: ["Managed Firewall", "Web App & Email Security", "Endpoint Protection", "Data Loss Prevention", "Zero-Trust Framework", "Identity & Access Management", "Patch Management"] },
      { name: "Detect", items: ["SIEM & Log Management", "Machine Learning Threat Detection", "Intrusion Detection & Prevention", "SOC as a Service"] },
      { name: "Respond", items: ["Incident Response", "Containment & Eradication", "AI Attack Identification", "Rapid Response Teams", "Restore & Recovery"] },
    ],
    compliance: ["NIST 800-53", "CMMC", "HIPAA", "PCI-DSS"],
    supplierNames: ["Fortinet", "Palo Alto", "Zscaler", "Arctic Wolf", "Check Point", "Cloudflare"],
  },
  "cloud-infrastructure-managed-services": {
    title: "Cloud Infrastructure & Managed Services",
    overline: "Resilient Infrastructure",
    intro:
      "From public cloud migration to multi-cloud orchestration and disaster recovery — we design infrastructure that guarantees business continuity during unexpected disruptions.",
    groups: [
      { name: "Data Center & Cloud", items: ["Public Cloud (AWS, Azure, GCP, Oracle, SAP HANA)", "Private Cloud", "Hybrid & Multi-Cloud", "Data Center Colocation", "Bare Metal"] },
      { name: "Platform & Continuity", items: ["IaaS / PaaS", "Disaster Recovery (DRaaS)", "Backup as a Service (BUaaS)", "Cloud & Managed Services"] },
      { name: "Storage & Connectivity", items: ["Object, File & Block Storage", "AWS Direct Connect", "Azure Express Routes", "Oracle FastConnect", "CDN & Data Fabrics"] },
      { name: "Managed & Pro Services", items: ["Helpdesk as a Service", "IT Outsourcing (ITO)", "Cloud Migration", "Application Management (ERP, CRM)", "Data Lakehouse", "Load Balancing"] },
    ],
    compliance: ["Multi-region resilience", "RTO/RPO engineering"],
    supplierNames: ["AWS", "Microsoft Azure", "Google Cloud", "Rackspace", "11:11 Systems", "Flexential"],
  },
  "ai-automation": {
    title: "Artificial Intelligence & Automation",
    overline: "Intelligent Operations",
    intro:
      "AI readiness assessments, generative AI roadmapping, and process automation — governed by an AI security framework so innovation never compromises compliance.",
    groups: [
      { name: "Applied AI", items: ["Conversational AI & Chatbots", "Generative AI Roadmapping", "Real-Time Agent Assist", "Virtual Assistants"] },
      { name: "Automation", items: ["Robotic Process Automation (RPA)", "Process Automation", "AI Application Optimization"] },
      { name: "AI Ops", items: ["AI-Driven Network Monitoring", "Performance & Billing Optimization", "Predictive Maintenance"] },
      { name: "Data & Analytics", items: ["Predictive Analytics", "LLM as a Service (LLMaaS)", "AI Computer Vision", "Data Lakehouse Strategy"] },
    ],
    compliance: ["AI Security Governance", "AI Readiness Assessments"],
    supplierNames: ["AWS", "Microsoft Azure", "Google Cloud", "Five9", "NICE CXone", "Genesys"],
  },
  "advanced-networking-connectivity": {
    title: "Advanced Networking & Connectivity",
    overline: "Mission-Critical Networks",
    intro:
      "SD-WAN, SASE, and dedicated connectivity engineered for seamless data flow across headquarters, remote branches, and multi-cloud environments.",
    groups: [
      { name: "SASE", items: ["SD-WAN", "CASB", "Auto-Failover", "Intelligent Routing", "VNF Firewall", "Application-Aware Networking"] },
      { name: "Connectivity", items: ["Dedicated Fiber", "Broadband / Coax", "WISP / Microwave", "4G/5G Internet", "Satellite Internet", "Aggregation"] },
      { name: "Wireless", items: ["LTE/4G/5G Connectivity", "Private LTE/5G", "Fixed Wireless", "Distributed Antenna Service (DAS)", "POTS Replacement over Cellular"] },
      { name: "Network Management", items: ["24/7 Monitoring & Management", "AI Ops", "Performance & Billing Optimization", "Advanced Networking Design"] },
    ],
    compliance: ["Carrier-neutral sourcing", "SLA negotiation"],
    supplierNames: ["AT&T", "Verizon", "Lumen", "Zayo", "Aryaka", "Cato Networks", "Cradlepoint"],
  },
  "unified-communications-ucaas": {
    title: "Unified Communications (UCaaS)",
    overline: "Connected Workforce",
    intro:
      "Cloud voice, Microsoft Teams and Zoom integration, and hybrid communications architecture that keeps your mobile workforce collaborating securely.",
    groups: [
      { name: "UCaaS Core", items: ["Voice & Video Calling", "Messaging & Chat", "Conferencing", "Voicemail & Caller ID", "Presence & Mobile Access"] },
      { name: "Collaboration", items: ["Microsoft Teams Integration", "Zoom Integration", "Collaboration Tools", "CRM Integrations"] },
      { name: "Platform (CPaaS)", items: ["Programmable Voice & SMS", "APIs & SDKs", "Embedded Communications"] },
      { name: "Premises & Devices", items: ["Prem as-a-Service", "SIP Trunks", "Handsets & Phones", "Tablets, eSIM & MultiSIM"] },
    ],
    compliance: ["Hybrid comms architecture", "Mobile workforce enablement"],
    supplierNames: ["RingCentral", "Zoom", "8x8", "Dialpad", "Nextiva", "Vonage"],
  },
  "contact-center-ccaas": {
    title: "Contact Center & CX Technology (CCaaS)",
    overline: "Customer Experience",
    intro:
      "Omnichannel customer journeys, AI self-service, and workforce engagement — a complete CX technology stack tuned with predictive analytics.",
    groups: [
      { name: "Contact Center Core", items: ["Automatic Call Distribution (ACD)", "Interactive Voice Response (IVR)", "Dialers (Preview, Power, Predictive)", "Call & Screen Recording", "Branded Caller ID", "APIs & SDKs"] },
      { name: "Omnichannel Engagement", items: ["Voice, Email & Chat", "SMS/Text & Social", "Video & Mobile", "Self-Service & AI Bots"] },
      { name: "Workforce Engagement", items: ["Workforce Management", "Workforce Optimization", "Gamification", "Agent Coaching & Performance", "Quality Management & Compliance"] },
      { name: "Intelligence", items: ["Reporting, Analytics & BI", "Real-Time Agent Assist", "CRM/ERP Integrations", "UC Integrations"] },
    ],
    compliance: ["Predictive analytics", "WEM optimization"],
    supplierNames: ["Five9", "NICE CXone", "Talkdesk", "Genesys", "8x8"],
  },
  "iot-mobility-solutions": {
    title: "IoT & Mobility Solutions",
    overline: "Connected Everything",
    intro:
      "Enterprise mobility management, IoT sensor networks, and smart fleet tracking — privacy-compliant connectivity for every device in your operation.",
    groups: [
      { name: "IoT Sensors & Verticals", items: ["Temperature, Pressure & Soil Sensors", "Smart City & Agriculture", "Manufacturing & Logistics", "Hospitality Solutions"] },
      { name: "Physical Security", items: ["IP Cameras & Video Analytics", "Access Control", "Video Surveillance"] },
      { name: "Energy & Fleet", items: ["Electric, Gas & Solar Monitoring", "EV Chargers", "Telematics & Geo-Fencing", "Velocity & Usage Reporting"] },
      { name: "Managed Mobility", items: ["Mobile Device Management (MDM/MDaaS)", "Staging & Kitting", "Helpdesk & Break/Fix", "Plan Optimization", "AI Performance & Billing Optimization"] },
    ],
    compliance: ["Privacy-compliant connectivity", "EMM governance"],
    supplierNames: ["AT&T", "Verizon", "Cradlepoint", "Granite"],
  },
};
